import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { IInspectionPlan } from 'src/app/inspection-plan/inspection-plan.interface';
import { InspectionPlanAssistantService } from '../inspection-plan-assistant/inspection-plan-assistant.service';
import { utcDayToLocal } from 'src/app/shared/utils/calendar-day.util';

@Component({
  selector: 'phdsoft-inspection-plan-selector',
  templateUrl: './inspection-plan-selector.component.html',
  styleUrls: ['./inspection-plan-selector.component.scss']
})
export class InspectionPlanSelectorComponent implements OnInit {
  @Input() inspectionTypeId: string;
  @Input() regionIds: string[] = [];
  @Output() planSelected = new EventEmitter<IInspectionPlan>();

  loading = false;
  inspectionPlans: IInspectionPlan[] = [];

  constructor(
    private assetManager: AssetManager,
    private inspectionPlanService: InspectionPlanAssistantService
  ) {}

  ngOnInit() {
    this.loadPlans();
  }

  private loadPlans() {
    const assetId = this.assetManager.asset.assetInfo.AssetId;
    const referenceDate = new Date(this.assetManager.referenceDate);

    this.loading = true;
    this.inspectionPlanService.getOpenPlansOutsideCurrentDate(
      assetId,
      this.regionIds,
      referenceDate,
      this.inspectionTypeId
    ).subscribe({
      next: (data) => {
        if(!data){
          this.loading = false;
          this.planSelected.emit(null);
          return;
        }
        
        if (data) {
          this.inspectionPlans = data.map(item => ({
            ...item,
            assetWindowEndsAt: this.removeTimeZoneFromDate(new Date(item.assetWindowEndsAt)),
            assetWindowStartsAt: this.removeTimeZoneFromDate(new Date(item.assetWindowStartsAt))
          }));
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  selectPlan(plan: IInspectionPlan) {
    if(!plan){
      this.planSelected.emit(null);
      return;
    }
    
    const plannedDate = this.removeTimeZoneFromDate(new Date(plan.plannedDate));
    this.inspectionPlanService.setInspectionPlanReferenceDate(plannedDate);
    this.assetManager.referenceDate = new Date(plannedDate);
    this.planSelected.emit(plan);
  }

  private removeTimeZoneFromDate(date: Date) {
    return utcDayToLocal(date);
  }
} 